/*
 * @Author: shen
 * @Date: 2021-07-17 22:39:15
 * @LastEditors: shen
 * @LastEditTime: 2021-07-25 23:33:12
 * @Description:
 */
import { isUndefined, assert, isPromise, isObject } from '../helpers/util';

class Store {
  constructor(options) {
    this._deps = [];
    this._state = { ...options.state, ...(options.globalState || {}) };
    this._globalKeys = Object.keys(options.globalState || {});
    this._mutations = options.mutations;
    this._actions = options.actions;

    const store = this;
    const { commit, _update, dispatch } = this;
    this._update = function boundUpdate(state) {
      return _update.call(store, state);
    };
    this.commit = function boundCommit(type, payload) {
      return commit.call(store, type, payload);
    };
    this.dispatch = function boundDispatch(type, payload) {
      return dispatch.call(store, type, payload);
    };
  }

  get state() {
    return this._state;
  }

  set state(v) {
    assert(false, `state is readonly, please use store.commit() update state`);
  }

  get globalKeys() {
    return this._globalKeys;
  }

  set globalKeys(v) {
    assert(false, `globalKeys is readonly`);
  }

  _update(state) {
    if (!isObject(state)) {
      console.error(`[wx-store] setData() params must be an Object`);
      return;
    }
    const exitState = {};
    for (const key in state) {
      if (!isUndefined(this._state[key])) {
        this._state[key] = state[key];
        exitState[key] = state[key];
      }
    }
    this._notify(exitState);
  }

  _notify(state) {
    this._deps.forEach((watcher) => {
      const needUpdateState = {};
      watcher.mapState.forEach((ms) => {
        if (!isUndefined(state[ms.val])) {
          needUpdateState[ms.key] = state[ms.val];
        }
      });
      const needKeys = Object.keys(needUpdateState);
      if (needKeys.length > 0) {
        watcher.update(needUpdateState);
      }
    });
  }

  commit(type, payload) {
    if (!this._mutations[type]) {
      console.error(`[wx-store] unknown mutation type: ${type}`);
      return;
    }
    const entry = this._mutations[type];
    entry(this._update, payload);
  }

  dispatch(type, payload) {
    if (!this._actions[type]) {
      console.error(`[wx-store] unknown action type: ${type}`);
      return;
    }
    const { commit, dispatch, state } = this;
    let entry = this._actions[type];
    let result = entry({ commit, dispatch, state }, payload);
    if (!isPromise(result)) {
      result = Promise.resolve(result);
    }
    return new Promise((resolve, reject) => {
      result.then(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
}

export default Store;
